import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const TextBulletIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M2.17273 7.06262H1.33939C1.05184 7.06262 0.818726 7.29573 0.818726 7.58329V8.41729C0.818726 8.70485 1.05184 8.93796 1.33939 8.93796H2.17273C2.46028 8.93796 2.69339 8.70485 2.69339 8.41729V7.58329C2.69339 7.29573 2.46028 7.06262 2.17273 7.06262Z"
        fill={color}
      />
      <path
        d="M2.17273 1.06262H1.33939C1.05184 1.06262 0.818726 1.29573 0.818726 1.58329V2.41729C0.818726 2.70484 1.05184 2.93796 1.33939 2.93796H2.17273C2.46028 2.93796 2.69339 2.70484 2.69339 2.41729V1.58329C2.69339 1.29573 2.46028 1.06262 2.17273 1.06262Z"
        fill={color}
      />
      <path
        d="M2.17273 13.0626H1.33939C1.05184 13.0626 0.818726 13.2957 0.818726 13.5833V14.4173C0.818726 14.7048 1.05184 14.938 1.33939 14.938H2.17273C2.46028 14.938 2.69339 14.7048 2.69339 14.4173V13.5833C2.69339 13.2957 2.46028 13.0626 2.17273 13.0626Z"
        fill={color}
      />
      <path
        d="M4.33333 8.66663L15.6667 8.66663C15.8508 8.66663 16 8.51739 16 8.33329V7.66663C16 7.48253 15.8508 7.33329 15.6667 7.33329L4.33333 7.33329C4.14924 7.33329 4 7.48253 4 7.66663V8.33329C4 8.51739 4.14924 8.66663 4.33333 8.66663Z"
        fill={color}
      />
      <path
        d="M4.33333 14.6666L15.6667 14.6666C15.8508 14.6666 16 14.5174 16 14.3333V13.6666C16 13.4825 15.8508 13.3333 15.6667 13.3333L4.33333 13.3333C4.14924 13.3333 4 13.4825 4 13.6666V14.3333C4 14.5174 4.14924 14.6666 4.33333 14.6666Z"
        fill={color}
      />
      <path
        d="M4.33333 2.66663L15.6667 2.66663C15.8508 2.66663 16 2.51739 16 2.33329V1.66663C16 1.48253 15.8508 1.33329 15.6667 1.33329L4.33333 1.33329C4.14924 1.33329 4 1.48253 4 1.66663V2.33329C4 2.51739 4.14924 2.66663 4.33333 2.66663Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TextBulletIcon.displayName = 'TextBulletIcon';
